import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { SeguridadModule } from './seguridad/seguridad.module';
import { RouterModule } from '@angular/router';
import { CoreModule } from './core/core.module';
import { DataTablesModule } from 'angular-datatables';
//import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { NgHttpLoaderModule } from 'ng-http-loader/ng-http-loader.module';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpBaseInterceptor } from '../app/core/resources/http/http.interceptor';
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
    SeguridadModule,
    CoreModule,
    DataTablesModule,
    HttpClientModule,
    NgHttpLoaderModule
    // NgxSpinnerModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpBaseInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
